import { connect } from 'react-redux';
import EndpointAccessManager from '../../../../components/userManagement/clients/EndpointAccessManager';
import { getAllGroups, getPermissions } from 'core/slices/clients';

import {
  getClientPermissions,
  isLoadingClientPermissions,
  getAllGroupsOptions,
  isLoadingAllGroups,
} from 'core/selectors';

export default connect(
  state => ({
    allGroups: getAllGroupsOptions(state),
    isLoadingAllGroups: isLoadingAllGroups(state),
    clientPermissions: getClientPermissions(state),
    loadingClientPermissions: isLoadingClientPermissions(state),
  }),
  {
    getAllGroups,
    getPermissions,
  },
)(EndpointAccessManager);
